<template>
  <div id="AboutMeCollage4" style="padding-top: 60%; padding-bottom: 25%;">
    <img
      id="FallingSticker3Anchor"
      fetchpriority="high"
      style="width: 50%; translate: 0% 0%;"
      src="/static/about-me/i25.webp"
    />
    <div>
      <img
        fetchpriority="high"
        style="width: 31%; translate: 0% 0%;"
        src="/static/about-me/i26.webp"
      />
      <img
        fetchpriority="high"
        style="width: 25%; translate: 1% 0%;"
        src="/static/about-me/i27.webp"
      />
      <img
        fetchpriority="high"
        style="width: 15%; translate: -12% 49%;"
        src="/static/about-me/i28.webp"
      />
    </div>
    <div>
      <img
        ref="target"
        fetchpriority="high"
        style="width: 33%; translate: 6% 63%; z-index: 1;"
        src="/static/about-me/i30.webp"
      />
      <img
        fetchpriority="high"
        style="width: 32%; translate: 0% 5%;"
        src="/static/about-me/i29.webp"
      />
      <img
        fetchpriority="high"
        style="width: 19%; translate: 17% 48%;"
        src="/static/about-me/i31.webp"
      />
    </div>
    <div>
      <img
        fetchpriority="high"
        style="width: 40%; translate: 0% 9%;"
        src="/static/about-me/i32.webp"
      />
    </div>

    <img
      fetchpriority="high"
      style="width: 80%; translate: 4% 40%;"
      src="/static/about-me/i33.webp"
    />

    <StickMe name="3" size="20" left="17" top="-3" uk-parallax="x: -60%" />
    <StickMe name="72" size="28" left="-3" top="0" uk-parallax="x: -120%" />
    <StickMe name="3" size="20" left="13" top="7" uk-parallax="x: -25%" />
    <StickMe name="1" size="12" left="30" top="5" uk-parallax="x: -15%" />
    <StickMe name="3" size="24" left="111" top="2" uk-parallax="x: -60%" />
    <StickMe name="53" size="24" left="65" top="10" uk-parallax="x: -60%" />
    <StickMe name="79" size="28" left="41" top="13" />
    <StickMe name="17" size="12" left="17" top="19" uk-parallax="x: -30%" />
    <StickMe
      name="17"
      size="10"
      left="42"
      top="25.5"
      uk-parallax="x: -30%"
      style="z-index: -1;"
    />
    <StickMe name="3" size="13" left="74" top="27" uk-parallax="x: -20%" />
    <StickMe name="17" size="9" left="7" top="32" uk-parallax="x: -20%" />
    <StickMe name="81" size="19" left="46" top="38" />
    <StickMe name="5" size="9" left="55" top="38" uk-parallax="x: -20%" />
    <StickMe name="82" size="26" left="80" top="39" />
    <StickMe name="3" size="16" left="83" top="42" uk-parallax="x: -20%" />
    <StickMe name="75" size="11" left="68" top="44" uk-parallax="y: -20%" />
    <StickMe name="84" size="14" left="16" top="49" style="z-index: 0;" />
    <StickMe
      name="83"
      size="13"
      left="10"
      top="43"
      uk-parallax="y: 20%"
      style="z-index: -1;"
    />
    <StickMe name="17" size="8" left="4" top="41" uk-parallax="x: -60%" />
    <StickMe name="3" size="12" left="0" top="51" uk-parallax="x: -20%" />
    <StickMe name="87" size="14" left="34" top="55" style="z-index: -1;" />
    <StickMe name="88" size="14" left="6.7" top="61.8" style="z-index: -1;" />
    <StickMe name="85" size="13" left="57" top="49" />
    <StickMe name="86" size="19" left="83" top="53.2" />
    <StickMe name="78" size="11" left="90" top="55" uk-parallax="y: 100%" />
    <StickMe name="3" size="14" left="73" top="62" uk-parallax="x: -20%" />
    <StickMe name="73" size="19" left="74" top="65" uk-parallax="x: -50%" />
    <StickMe name="74" size="23" left="64" top="77" uk-parallax="x: -10%" />
    <StickMe name="90" size="23" left="28" top="79.2" />
    <StickMe name="89" size="15" left="26" top="71" />
    <StickMe name="5" size="7" left="26" top="68" uk-parallax="x: -20%" />
    <StickMe name="75" size="10" left="21" top="67.4" uk-parallax="x: -10%" />
    <StickMe
      name="91"
      size="28"
      left="105"
      top="74"
      uk-parallax="x: -800%; y: 300%"
    />
    <StickMe name="77" size="17" left="13" top="82" />
    <StickMe name="3" size="17" left="7" top="88" uk-parallax="x: -25%" />
    <StickMe name="93" size="14" left="96" top="94" style="z-index: -1;" />
    <StickMe name="92" size="14" left="96" top="85" style="z-index: -1;" />
    <StickMe name="94" size="37" left="9" top="96" />
    <StickMe
      name="76"
      size="10"
      left="91"
      top="82"
      uk-parallax="rotate: 45; scale: 1.2"
    />

    <StickMe
      ref="stickerAnchor"
      name="80"
      size="21"
      left="20"
      top="31"
      style="opacity: 0;"
    />
    <div
      ref="stickerContainer"
      class="sticker"
      :style="{
        opacity: hide ? 0 : 1,
        top: '31%',
        left: '20%',
        width: '21%',
        zIndex: 0,
      }"
    >
      <StickMe
        ref="sticker"
        name="80"
        size="100"
        style="translate: 0%;"
        uk-parallax="target: #FallingSticker3Anchor; y: -50%, 10%"
      />
    </div>
  </div>
</template>

<script>
import StickMe from './StickMe.vue'

export default {
  components: {
    StickMe,
  },
  data() {
    return {
      hide: false,
    }
  },
  methods: {
    emitHide() {
      let target = this.$refs.target
      let targetRect = target.getBoundingClientRect()

      let startAt = 200

      if (targetRect.top < startAt) {
        this.hide = true
      } else {
        this.hide = false
      }
    },
    onScroll() {
      this.emitHide()

      let stickerAnchor = this.$refs.stickerAnchor.$el
      let stickerAnchorRect = stickerAnchor.getBoundingClientRect()
      let stickerContainer = this.$refs.stickerContainer

      let startAt = 200

      if (stickerAnchorRect.top > startAt) {
        stickerContainer.style.position = 'absolute'
        stickerContainer.style.top = stickerAnchor.style.top
        stickerContainer.style.left = stickerAnchor.style.left
        stickerContainer.style.translate = stickerAnchor.style.translate
      } else if (stickerAnchorRect.top < startAt) {
        stickerContainer.style.position = 'fixed'
        stickerContainer.style.top = `${startAt}px`
        stickerContainer.style.left = `${stickerAnchorRect.left}px`
        stickerContainer.style.width = `${stickerAnchorRect.width}px`
        stickerContainer.style.height = `${stickerAnchorRect.height}px`
        stickerContainer.style.translate = '0%'
      }
    },
  },
  mounted() {
    window.addEventListener('scroll', this.onScroll, { passive: false })
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.onScroll)
  },
}
</script>



// WEBPACK FOOTER //
// src/components/about-me/AboutMeCollage4.vue